import React from 'react'
import CalendarContainer from '../../../Components/Applications/Calendar'

export default function Calendar() {
  return (
    <div className='page-body'>
      <CalendarContainer />
    </div>
  )
}